import { Grid, IconButton } from "@mui/material";
import React from "react";
import Flex from "../../../../../../components/Flex";
import OutlineCard from "../../../../../../components/OutlineCard";
import Text from "../../../../../../components/Text";
import {
  getXtenantId,
  replaceUnderScoreAddSpace,
} from "../../../../../../utils/utils";
import { useGetClaimIntegration } from "../../../../../../queries/billings/claim-integration/use-get-claim-integration";
import ProfileViewer from "../../../../../../components/ProfileViewer";

import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CreateClaimIntegrationDrower from "../../claim-integration/CreateClaimIntegrationDrower";
import useDisclosure from "../../../../../../hooks/use-disclosure";
import StyledButtonV2 from "../../../../../../components/app/StyledButtonV2";
import DeleteModal from "../../../../../../components/app/DeleteModal";
import { useClaimIntegrationArchive } from "../../../../../../queries/billings/claim-integration/use-claim-integration-archive";
import { useArchiveState } from "../../../../../../hooks/useArchiveState";

const ClaimIntegrationDetails: React.FC = () => {
  const addClaimIntegrationModalDisclosure = useDisclosure(false);
  const { data: claimIntegrationList, refetch } = useGetClaimIntegration({
    xtenantId: getXtenantId() ?? "",
  });

  // Delete = archive the payer/clearinghouse configuration so it is excluded
  // from all future payer-dependent workflows (ECRH-5375). Uses the BE
  // archive-status API; the archive filter on the listing hides it afterwards.
  const { mutateAsync: archiveClaimIntegration } = useClaimIntegrationArchive();
  const { archiveHandler, deleteDisc } = useArchiveState(
    archiveClaimIntegration
  );

  return (
    <OutlineCard sx={{ height: "100%" }}>
      <CreateClaimIntegrationDrower
        disClosureHost={addClaimIntegrationModalDisclosure}
        title={
          addClaimIntegrationModalDisclosure.data
            ? "Edit Claim Integration"
            : "Create Claim Integration"
        }
      />
      <DeleteModal
        w="420px"
        title="Delete Payer Configuration"
        open={deleteDisc.opened}
        onClose={deleteDisc.close}
        id={deleteDisc.deleteId}
        cancelButtonText="Cancel"
        confirmButtonText="Delete"
        onConfirmation={(id) =>
          archiveHandler(true, id).then((res) => {
            refetch();
            return res;
          })
        }
        content={
          "Are you sure you want to delete this payer configuration? This configuration will no longer be available for future claim submissions, eligibility verification, and other payer-related transactions. Previously submitted or processed claims and completed transactions will not be affected. This action cannot be undone."
        }
      />
      <Flex
        justifyContent="space-between"
        alignItems="center"
        marginBottom="20px"
      >
        <Text fontSize="16px" fontWeight="600">
          Claim Integration Details
        </Text>
        <StyledButtonV2
          label="Add Claim Integration"
          onClick={() => addClaimIntegrationModalDisclosure.open()}
          shouldAddIcon
        />
      </Flex>

      <Grid container spacing={3}>
        {(claimIntegrationList?.data as unknown as any[])?.map(
          (claimIntegration) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={claimIntegration.uuid}>
              <OutlineCard
                sx={{ border: 0, position: "relative", height: "100%" }}
              >
                <Flex
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                  }}
                  gap={0.25}
                >
                  <IconButton
                    size="small"
                    onClick={() =>
                      addClaimIntegrationModalDisclosure.open(claimIntegration)
                    }
                  >
                    <ModeEditOutlineOutlinedIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => deleteDisc.open(claimIntegration.uuid)}
                  >
                    <DeleteOutlineOutlinedIcon fontSize="small" color="error" />
                  </IconButton>
                </Flex>

                <ProfileViewer
                  data={{
                    "Vendor Type":
                      replaceUnderScoreAddSpace(claimIntegration.vendor) || "",
                    "SFTP Host": claimIntegration.sftpHost || "",
                    "SFTP Username": claimIntegration.sftpUsername || "",
                    // "SFTP Password": claimIntegration.sftpPassword || "",
                    "User ID": claimIntegration.userId || "",
                    // Password: claimIntegration.password || "",
                  }}
                  firstColW={4}
                  secondColW={8}
                  withoutColn
                />
              </OutlineCard>
            </Grid>
          )
        )}
      </Grid>
    </OutlineCard>
  );
};

export default ClaimIntegrationDetails;
